/**
 * Created by lihanying on 2017/6/20.
 */
import { GETPORTALSUCCESS } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETPORTALSUCCESS:
      return Object.assign({}, state, { portal: action.payload })
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/Portal/reduce.js